<template>
  <el-dialog
    v-if="dialogVisible"
    ref="dialog"
    v-dialogDrag
    title="题库问题清单"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1100px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col
            :span="3"
            style="padding-left: 10px;"
          >
            <el-input
              v-model="tableList.tableQuery.question"
              placeholder="问题内容"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData(tableList)"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="tableList.tableQuery.type"
              placeholder="问题类别"
              clearable
              style="width:100%"
              @keyup.enter.native="loadTableData(tableList)"
            >
              <el-option
                label="单选题"
                value="2"
              />
              <el-option
                label="多选题"
                value="3"
              />
              <el-option
                label="问答题"
                value="4"
              />
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
            <el-button
              type="success"
              @click="handleChooseQuestion"
            >
              选择
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table2
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="true"
          :is-select-field="true"
          :multiple-selection.sync="multipleSelection"
          is-index-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @chooseQuestion="handleChooseQuestion"
          @reloadData="loadTableData(tableList)"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin2 from '@/mixin/dialogTableCustomMixin2'
// 题库-问题API
import { loadQuestionListDataApi } from '@/api/v2/question'

// 数据请求
export default {
  name: 'SearchQuestionForAction',
  components: { CustomTable2 },
  mixins: [dialogDragMixin, dialogTableCustomMixin2],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      tableList: {
        // Table初始化列
        initTableColumn: [],
        // Table列
        tableColumns: [],
        // Table Key
        tableKey: 'search_for_action_question_table',
        // Table Index
        tableIndex: 0,
        // Table加载状态
        tableLoading: false,
        // Table数据
        tableData: [],
        // Table总数据条数
        tableDataTotal: 0,
        // Table右键
        tableContextmenu: [
          {
            prop: 'chooseQuestion',
            label: '选择调研问题',
            method: 'chooseQuestion'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          question: '',
          type: '',
          status: 2
        }
      },
      multipleSelection: [],

    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.multipleSelection = [];
        _this.tableList.initTableColumn = [
          { prop: 'typeValue', label: '问题类别', filterColumn: 'type', filterValue: 'type', filterArray: [{ label: '单选题', value: 2 }, { label: '多选题', value: 3 }, { label: '问答题', value: 4 }], width: 120 },
          { prop: 'question', label: '问题内容' },
          { prop: 'operationTime', filterColumn: 'operation_time', label: '操作时间', width: 150, isBetween: true }
        ];
        _this.tableList.tableColumns = _this.tableList.initTableColumn;
        _this.loadTableData(_this.tableList);
      }
    }
  },
  methods: {
    // 选择调研问题
    handleChooseQuestion () {
      let _this = this;
      if (_this.multipleSelection.length === 0) {
        _this.$message({ message: '请选择调研问题', type: 'warning' })
        return
      }

      _this.$emit('chooseActionQuestion', _this.multipleSelection)
      _this.modalClose()
    },
    // 请求数据
    requestData () {
      let _this = this;
      loadQuestionListDataApi(_this.tableList.tableQuery).then(response => {
        const { data } = response;
        _this.handleData(_this.tableList, data.list || []);
        _this.tableList.tableDataTotal = data.total || 0;
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      // 直接修改父组件的属性
      this.$emit('update:dialogVisible', false)
    },
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
